import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    name: 'Carmen S.',
    time: 'Hace 2 horas',
    text: 'Día 3: Por fin un paseo sin que me duela el hombro. No me lo creo.'
  }, {
    avatar: 'https://randomuser.me/api/portraits/women/32.jpg',
    name: 'Laura G.',
    time: 'Hace 3 días',
    text: 'Día 4: Mi perro me miró al cruzarme con otro en lugar de estallar. Por fin hay comunicación.'
  }, {
    avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
    name: 'Miguel A.',
    time: 'Hace 1 semana',
    text: 'He recuperado la movilidad de mi hombro. Los tirones han desaparecido de verdad.'
  }, {
    avatar: 'https://randomuser.me/api/portraits/women/55.jpg',
    name: 'Patricia R.',
    time: 'Hace 5 días',
    text: 'El Bono del Perro Cafetero es magia. Acabo de cenar en una terraza con él durmiendo bajo la mesa.'
  }];
  return <section className="py-12 px-5" data-id="element-285">
      <div className="max-w-lg mx-auto" data-id="element-286">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 leading-tight" data-id="element-287">
          Únete a los +5.700 dueños que ya disfrutan del silencio.
        </h2>

        <div className="flex flex-col gap-4" data-id="element-288">
          {testimonials.map((t, index) => <div key={index} className="glass-teal rounded-2xl p-5 shadow-sm" data-id="element-289">
              <div className="flex items-center gap-3 mb-3" data-id="element-290">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover shadow-sm border border-teal/30" data-id="element-291" />
                <div data-id="element-292">
                  <p className="font-bold text-white text-sm" data-id="element-293">{t.name}</p>
                  <p className="text-white/40 text-xs" data-id="element-294">{t.time}</p>
                </div>
              </div>
              <p className="text-white/90 text-[15px] leading-relaxed" data-id="element-295">
                {t.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}